import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RegistryAction } from '../../store/registry.action';

@Injectable()
export class RegistryCleanResolver implements Resolve<any> {

    constructor(private store: Store) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        if(route.queryParams.clear){
            this.store.dispatch(new RegistryAction.Clear);
        }
        return null;
    }
}
